import Home from '../views/Home.vue';
import Vue from 'vue';
import VueRouter from 'vue-router';
import PasswordChangeView from '../views/PasswordChangeView.vue';
import PasswordChangeRequestView from '../views/PasswordChangeRequestView.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/filter',
    name: 'LdFilterView',
    meta: {
      requiresAuth: true
    },
    component: function () {
      return import('../views/LdFilterView.vue');
    }
  },
  {
    path: '/list',
    name: 'ListView',
    meta: {
      requiresAuth: true
    },
    component: function () {
      return import('../views/ListView.vue');
    }
  },
  {
    path: '/password/change/request',
    name: 'PasswordChangeRequestView',
    component: PasswordChangeRequestView
  },
  {
    path: '/password/change',
    name: 'PasswordChangeView',
    component: PasswordChangeView
  }
]

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!router.app.$actions.isLoggedIn(router.app.$store.state)) {
      next({
        path: '/',
        query: {
          redirect: 'Home'
        }
      });
    } else {
      next()
    }
  } else {
    next();
  }
});

export default router;